module.exports = __webpack_public_path__ + "static/media/13.c6fd49c0.jpg";